"use client"

export default function GoogleMap({ latitude, longitude, villaName = "Villa", googleMapsLink }) {
  // OpenStreetMap embed with a marker pin at the villa location
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${longitude - 0.008},${latitude - 0.005},${longitude + 0.008},${latitude + 0.005}&layer=mapnik&marker=${latitude},${longitude}`;

  // Build the Google Maps link to open on click
  const gmapsUrl =
    googleMapsLink ||
    `https://www.google.com/maps/search/${encodeURIComponent(villaName)}/@${latitude},${longitude},17z`;

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const handleMapClick = () => {
    window.open(gmapsUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="w-full h-full rounded-lg overflow-hidden relative">
      <iframe
        src={mapUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        title={`${villaName} Location`}
      ></iframe>
      {/* Clickable overlay on mobile to redirect to Google Maps */}
      {isMobile && (
        <button
          type="button"
          onClick={handleMapClick}
          className="absolute inset-0 z-10"
          aria-label="Open in Google Maps"
        />
      )}
    </div>
  );
}
